import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import api from "../../services/api";
import Slct from "../Slct";
import { File, InputTextArea } from "../Input";
import Checkbox from "../../components/Checkbox";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import useWrapper from "../../hooks/useWrapper";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";
import Required from "../Required";
import getCommercial from "../../util/getCommercial";
import ModalCustom from "./modal-template-default";
import { uploadFile } from "../../hooks/api/uploadFile";
import { validateForm, validateStyle } from "../../components/ValidateForm";
import FileUpload from "../FileUpload";

const ModalNewMessage = props => {
  const { show, onHide, commercialId = null } = props;
  const navigate = useNavigate();
  const { me, config, token } = useWrapper();
  const commercial_id = me.type === "Formando" ? me.commercial_id : commercialId;
  const prefix_url = me.type === "Formando" ? "trainee/" : "";

  useEffect(() => {
    if (!show) setselects();
  }, [show]);
  const [commercials, setcommercials] = useState();
  const [categories, setcategories] = useState();
  const [trainees, settrainees] = useState();

  const [isLoadingTrainees, setisLoadingTrainees] = useState(false);
  const [isLoadingStartup, setisLoadingStartup] = useState(true);
  const [isLoadingRequest, setisLoadingRequest] = useState();

  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  useEffect(() => {
    setisWaitingResponse(isLoadingStartup || isLoadingTrainees || isLoadingRequest);
  }, [isLoadingStartup, isLoadingTrainees, isLoadingRequest]);

  const [selects, setselects] = useState();

  useEffect(() => {
    (async () => {
      try {
        setisLoadingStartup(true);
        const _commercials = me.type === "Gestor" ? await getCommercial() : [];
        setcommercials(_commercials);
        const { data: _categories } = await api.get(`${prefix_url}categories?paginate=false`, config);
        setcategories(
          _categories.map(__category => ({
            value: __category?.id,
            label: __category?.name,
            resources: __category?.resource?.map(__resource => ({
              value: __resource?.id,
              label: __resource?.name,
            })),
          })),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar os dados.");
      } finally {
        setisLoadingStartup(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (selects?.commercial_id) {
      (async () => {
        try {
          setisLoadingTrainees(true);
          const { data: _trainees } = await api.get(
            `${prefix_url}trainees?joins=null&paginate=false&commercial_id=${selects?.commercial_id}`,
            config,
          );
          settrainees(
            _trainees?.map(__trainee => ({
              value: __trainee.id,
              label: __trainee.name,
            })),
          );
        } catch (__error) {
          console.log(__error);
          toast.error("Erro ao carregar a lista de formandos.");
        } finally {
          setisLoadingTrainees(false);
        }
      })();
    }
  }, [selects?.commercial_id]);

  const submitAttendance = async () => {
    const _is_valid = validateForm(document.getElementById("new_message"));
    if (!_is_valid) return;
    try {
      setisLoadingRequest(true);
      const { data: __attendance } = await api.post(
        `${prefix_url}attendance`,
        {
          ...(!selects?.commision_only ? { trainee_id: selects?.trainee_id } : {}),
          category_id: selects?.category_id,
          resource_id: selects?.resource_id,
          // description: selects?.message,
          ...(me?.type === "Formando"
            ? {
                trainee_id: me?.id,
                user_id: null,
                status: "aguardandoEquipe",
                commercial_id: me?.commercial_id,
                commission_only: false,
              }
            : {
                user_id: me?.id,
                status: "aguardandoFormando",
                commercial_id: selects?.commercial_id,
                commission_only: selects?.commision_only || false,
              }),
        },
        config,
      );

      let _files = [];
      if (selects?.files?.length > 0) {
        try {
          for (const __file of selects?.files) {
            const { data: _file } = await uploadFile({
              file: __file,
              token,
              prefix: prefix_url || "",
            });
            _files.push(_file.id);
          }
        } catch (__error) {
          console.log("__error", __error);
          toast.error("Erro ao tentar subir os arquivos.");
        }
      }
      await api.post(
        `${prefix_url}attendance-messages`,
        {
          message: selects?.message,
          private: false,
          attendance_id: __attendance?.id,
          files: _files,
          ...(me?.type === "Formando"
            ? {
                trainee_id: me?.id,
              }
            : {
                user_id: me?.id,
              }),
        },
        config,
      );
      onHide();
      toast.success("Atendimento criado com sucesso.");
      if (me?.type === "Formando") {
        navigate(`/formando-dashboard/atendimento/mensagem/${__attendance.id}`);
      } else {
        navigate(`/attendance/edit/${__attendance.id}`);
      }
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar criar o Atendimento.");
    } finally {
      setisLoadingRequest(false);
    }
  };

  return (
    <ModalCustom
      show={show}
      onHide={onHide}
      size="lg"
      id="new_message"
      disableClose={!!isWaitingResponse}
      style={validateStyle}
    >
      <ModalCustom.Header>
        <h2 className="page-title">Novo Atendimento</h2>
      </ModalCustom.Header>
      <Form>
        <ModalCustom.Body>
          {me?.type === "Gestor" && (
            <>
              <Row className="mb-2">
                <Col>
                  <span>
                    Turma <Required />
                  </span>
                  <Slct
                    required={true}
                    isDisabled={!!commercial_id || !!isWaitingResponse}
                    options={commercials || []}
                    onChange={__ev => {
                      setselects({
                        ...selects,
                        commercial_id: __ev.value,
                      });
                    }}
                    value={selects?.commercial_id}
                    placeholder="Selecione a Turma"
                  />
                </Col>
              </Row>
              {!!selects?.commercial_id && (
                <>
                  <Row>
                    <Col>
                      <span className="d-flex">
                        <label style={{ cursor: "pointer" }}>
                          <Checkbox
                            disabled={!!isWaitingResponse}
                            checked={selects?.commision_only}
                            onChange={__ev => {
                              setselects({
                                ...selects,
                                commision_only: __ev.target.checked,
                                trainee_id: null,
                              });
                            }}
                          />
                          <span className="ml-1">Atendimento em nome da Comissão</span>
                        </label>
                      </span>
                    </Col>
                  </Row>
                  {!selects?.commision_only && (
                    <Row className="mt-2 mb-2">
                      <Col>
                        <span>
                          Formando <Required />
                        </span>
                        {!isLoadingTrainees ? (
                          <Slct
                            isDisabled={!!isWaitingResponse}
                            required={true}
                            options={trainees || []}
                            value={selects?.trainee_id}
                            onChange={__ev => {
                              setselects({
                                ...selects,
                                trainee_id: __ev.value,
                              });
                            }}
                            placeholder="Selecione o formando"
                          />
                        ) : (
                          <Loading small />
                        )}
                      </Col>
                    </Row>
                  )}
                </>
              )}
              <div className="divisor mt-3 mb-2"></div>
            </>
          )}
          <Row>
            <Col xs={6}>
              <span>
                Categoria <Required />
              </span>
              <Slct
                isDisabled={!!isWaitingResponse}
                required={true}
                options={categories || []}
                value={selects?.category_id}
                onChange={__ev => {
                  setselects({
                    ...selects,
                    category_id: __ev.value,
                    resource_id: null,
                  });
                }}
                placeholder="Selecione a categoria"
              />
            </Col>
            <Col xs={6}>
              <span>
                Recurso <Required />
              </span>
              <Slct
                isDisabled={!!isWaitingResponse}
                required={true}
                options={categories?.find(__category => __category?.value === selects?.category_id)?.resources || []}
                value={selects?.resource_id}
                onChange={__ev => {
                  setselects({
                    ...selects,
                    resource_id: __ev.value,
                  });
                }}
                placeholder="Selecione o recurso"
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <Form.Group as="label" className="d-block">
                <span className="d-block">
                  Mensagem <Required />
                </span>
                <InputTextArea
                  required={true}
                  disabled={!!isWaitingResponse}
                  rows={4}
                  value={selects?.message}
                  onChange={__ev => {
                    setselects({
                      ...selects,
                      message: __ev.target.value,
                    });
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <FileUpload
                files={selects?.files}
                setfiles={__ev => {
                  setselects({
                    ...selects,
                    files: __ev,
                  });
                }}
                loading={!!isWaitingResponse}
                label="Anexar Arquivos"
              />
            </Col>
          </Row>
        </ModalCustom.Body>
        <ModalCustom.Footer>
          <div className="d-flex justify-content-end align-items-center flex-grow-1">
            <Button
              loading={isLoadingRequest}
              type="submit"
              onClick={() => {
                submitAttendance();
              }}
            >
              Criar Atendimento
            </Button>
          </div>
        </ModalCustom.Footer>
      </Form>
    </ModalCustom>
  );
};

export default ModalNewMessage;
